import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Row, Col } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../../components/profileSetting/superAdmin/editProfile.css";
import { toast } from "react-toastify";
import { handleChangePassword } from "../../store/actions/userActions";
import Loader from "../../assets/images/loader.gif";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { user, isLoading } = useSelector((state) => state.user);
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [validated, setValidated] = useState(false);

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      if (formData.newPassword !== formData.confirmPassword) {
        toast.warning("New Password and Confirm Password must match!");
        return;
      }
      dispatch(handleChangePassword(user.id, formData));
      handleReset();
    }
    setValidated(true);
  };

  const handleReset = () => {
    setFormData({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setValidated(false);
  };

  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit} className="pt-4">
      <Row className="gy-4">
        {/* Current Password */}
        <Col md={4}>
        <Form.Group controlId="oldPassword" className="position-relative">
  <Form.Label>
    Current Password <span className="text-danger">*</span>
  </Form.Label>

  <div className="position-relative">
    <Form.Control
      type={showPassword.oldPassword ? "text" : "password"}
      placeholder="Enter current password"
      value={formData.oldPassword}
      onChange={(e) =>
        setFormData({ ...formData, oldPassword: e.target.value })
      }
      isInvalid={validated && !formData.oldPassword}
      required
    />
<Form.Control.Feedback type="invalid">
    Please enter your current password.
  </Form.Control.Feedback>
    <span
      className="password-toggle-icon"
      onClick={() => togglePasswordVisibility("oldPassword")}
      style={{
        position: "absolute",
        right: "30px", // Adjust if needed
        top: "35%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        //color: validated && !formData.oldPassword ? "red" : "inherit",
      }}
    >
      {showPassword.oldPassword ? <FaEye /> : <FaEyeSlash />}
    </span>
  </div>

  
</Form.Group>

        </Col>

        {/* New Password */}
        <Col md={4}>
          <Form.Group controlId="newPassword" className="position-relative">
            <Form.Label>
              New Password <span className="text-danger">*</span>
            </Form.Label>
            <div className="position-relative">
            <Form.Control
              type={showPassword.newPassword ? "text" : "password"}
              placeholder="Enter new password"
              value={formData.newPassword}
              onChange={(e) =>
                setFormData({ ...formData, newPassword: e.target.value })
              }
              isInvalid={validated && !formData.newPassword}
              required
            />
            <Form.Control.Feedback type="invalid">
              Please enter your new password.
            </Form.Control.Feedback>

<span
      className="password-toggle-icon"
      onClick={() => togglePasswordVisibility("newPassword")}
      style={{
        position: "absolute",
        right: "30px", // Adjust if needed
        top: "35%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        //color: validated && !formData.oldPassword ? "red" : "inherit",
      }}
    >
      {showPassword.newPassword ? <FaEye /> : <FaEyeSlash />}
    </span>
    </div>
           
            {/* {showPassword.newPassword ? (
              <FaEye
                onClick={() => togglePasswordVisibility("newPassword")}
                className="password-toggle-icon"
                style={{
                  marginRight: validated && !formData.newPassword ? "1rem" : "0",
                  
                }}
                
              />
            ) : (
              <FaEyeSlash
                onClick={() => togglePasswordVisibility("newPassword")}
                className="password-toggle-icon"
                style={{
                  marginRight: validated && !formData.newPassword ? "1rem" : "0",
                 
                }}
                
              />
            )} */}
             
          </Form.Group>
        </Col>

        {/* Confirm Password */}
        <Col md={4}>
          <Form.Group controlId="confirmPassword" className="position-relative">
            <Form.Label>
              Confirm Password <span className="text-danger">*</span>
            </Form.Label>
            <div className="position-relative">
            <Form.Control
              type={showPassword.confirmPassword ? "text" : "password"}
              placeholder="Confirm new password"
              value={formData.confirmPassword}
              onChange={(e) =>
                setFormData({ ...formData, confirmPassword: e.target.value })
              }
              isInvalid={validated && !formData.confirmPassword}
              required
            />
            <Form.Control.Feedback type="invalid">
              Please confirm your new password.
            </Form.Control.Feedback>
            <span
      className="password-toggle-icon"
      onClick={() => togglePasswordVisibility("confirmPassword")}
      style={{
        position: "absolute",
        right: "30px", // Adjust if needed
        top: "35%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        //color: validated && !formData.oldPassword ? "red" : "inherit",
      }}
    >
      {showPassword.confirmPassword ? <FaEye /> : <FaEyeSlash />}
    </span>
    </div>
            {/* {showPassword.confirmPassword ? (
              <FaEye
                onClick={() => togglePasswordVisibility("confirmPassword")}
                className="password-toggle-icon"
              />
            ) : (
              <FaEyeSlash
                onClick={() => togglePasswordVisibility("confirmPassword")}
                className="password-toggle-icon"
              />
            )} */}
          </Form.Group>
        </Col>
      </Row>

      {/* Buttons */}
      <div className="text-end mt-4">
        <Button
          variant="outline-success"
          className="cancel-button mx-2"
          onClick={handleReset}
        >
          Cancel
        </Button>
        <Button type="submit" className="button">
          Submit
        </Button>
      </div>
    </Form>
  );
};

export default ChangePassword;
